import { StyledSummaryBarCellLabelElement } from "./Detail.styles";

const SummaryBarCellLabel = ({ children }) => {
  return <StyledSummaryBarCellLabelElement>{children}</StyledSummaryBarCellLabelElement>;
};

export { SummaryBarCellLabel };
